var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ce-blog-article-overview',{attrs:{"articles":_vm.articles},scopedSlots:_vm._u([{key:"read-more",fn:function(){return [_vm._t("read-more",function(){return [_vm._v("Read more")]})]},proxy:true},{key:"heading",fn:function(){return [_vm._t("heading")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }